import { adminApiClient, createModeratorApiClient } from '../utils/apiClient';

const admin = adminApiClient;
const mod = createModeratorApiClient();

/**
 * Scraper Quota / Client Config API.
 * Admin routes use JWT (adminApiClient); the moderator self-status route
 * uses the moderator API key (createModeratorApiClient), same pattern as
 * openaiUsageApi.js / statsApi.js.
 */
export const scraperQuotaApi = {
  /**
   * Admin dashboard aggregate across every client.
   * @returns {Promise<import('axios').AxiosResponse<{ clients: Array<{
   *   client_id: number; client_name: string; client_email: string;
   *   scraper_enabled: boolean; auto_used_today: number; auto_run_per_day: number;
   *   extra_used_period: number; extra_runs_limit: number; total_estimated_cost: number;
   *   total_url_count: number; total_article_count: number; recent_runs: number;
   * }> }>>}
   */
  usageOverview: (config = {}) => admin.get('/admin/scraper-usage/overview', config),

  /** @param {number|string} clientId */
  getConfig: (clientId, config = {}) =>
    admin.get(`/admin/clients/${clientId}/scraper-config`, config),

  /**
   * @param {number|string} clientId
   * @param {{
   *   auto_run_per_day: number;
   *   extra_runs_limit: number;
   *   extra_run_period: string;
   *   max_articles_per_url: number; // 1-200
   *   max_urls_per_moderator_run: number;
   *   scraper_enabled: boolean;
   *   effective_from?: string;
   *   effective_to?: string;
   *   reason?: string;
   * }} body
   */
  putConfig: (clientId, body, config = {}) =>
    admin.put(`/admin/clients/${clientId}/scraper-config`, body, config),

  /** @param {number|string} clientId */
  getUsage: (clientId, params = {}, config = {}) =>
    admin.get(`/admin/clients/${clientId}/scraper-usage`, {
      ...config,
      params: { ...params, ...config.params },
    }),

  /**
   * Moderator self quota status — powers ScraperPoolPage badges and the
   * run-now precheck (max_urls_per_moderator_run, extra_remaining, etc).
   * @returns {Promise<import('axios').AxiosResponse<{
   *   scraper_enabled: boolean;
   *   max_articles_per_url: number;
   *   max_urls_per_moderator_run: number;
   *   auto_run_per_day: number;
   *   auto_used_today: number;
   *   auto_remaining_today: number;
   *   extra_remaining: number;
   *   extra_runs_limit: number;
   *   active_source_count: number;
   * }>>}
   */
  meQuota: (config = {}) => mod.get('/moderators/me/scraper-quota', config),
};

export default scraperQuotaApi;
